/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function WorkflowFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="workflow-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 6.5C11.996 6.582 11.996 6.664 11.988 6.745C11.964 6.989 11.904 7.23 11.81 7.457C11.526 8.143 10.936 8.677 10.226 8.892C10.069 8.94 9.908 8.972 9.745 8.988C9.664 8.996 9.582 8.996 9.5 9C9.418 8.996 9.336 8.996 9.255 8.988C9.092 8.972 8.931 8.94 8.774 8.892C8.064 8.677 7.474 8.143 7.19 7.457C7.096 7.23 7.036 6.989 7.012 6.745C7.004 6.664 7.004 6.582 7 6.5C7.004 6.418 7.004 6.336 7.012 6.255C7.036 6.011 7.096 5.77 7.19 5.543C7.474 4.857 8.064 4.323 8.774 4.108C8.931 4.06 9.092 4.028 9.255 4.012C9.336 4.004 9.418 4.004 9.5 4C9.582 4.004 9.664 4.004 9.745 4.012C9.989 4.036 10.23 4.096 10.457 4.19C11.143 4.474 11.677 5.064 11.892 5.774C11.94 5.931 11.972 6.092 11.988 6.255C11.996 6.336 11.996 6.418 12 6.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M12 6.5L21.5 6.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M22 17.5C21.996 17.582 21.996 17.664 21.988 17.745C21.964 17.989 21.904 18.23 21.81 18.457C21.493 19.221 20.799 19.791 19.988 19.952C19.827 19.984 19.664 20 19.5 20C19.418 20 19.337 19.992 19.255 19.988C19.174 19.976 19.092 19.968 19.012 19.952C18.771 19.904 18.538 19.821 18.322 19.705C17.667 19.355 17.193 18.716 17.048 17.988C17.016 17.827 17 17.664 17 17.5C17 17.418 17.008 17.337 17.012 17.255C17.024 17.174 17.032 17.092 17.048 17.012C17.08 16.852 17.128 16.695 17.19 16.543C17.474 15.857 18.064 15.323 18.774 15.108C18.931 15.06 19.092 15.028 19.255 15.012C19.336 15.004 19.418 15.004 19.5 15C19.582 15.004 19.664 15.004 19.745 15.012C19.989 15.036 20.23 15.096 20.457 15.19C21.143 15.474 21.677 16.064 21.892 16.774C21.94 16.931 21.972 17.092 21.988 17.255C21.996 17.336 21.996 17.418 22 17.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M17 17.5C12.858 17.5 9.5 14.142 9.5 10L9.5 9" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.5 6.5L7 6.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={9.5} cy={6.5} r={2.5} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={19.5} cy={17.5} r={2.5} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
